import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Sidebar from './Component/Comman/Sidebar';
import MainIndex from './Screen/MainIndex';
import { Switch, useNavigate, withRouter } from 'react-router-dom';
import AuthIndex from './Screen/AuthIndex';
import ProtectedRoute from './Component/Comman/ProtectedRoute';
import menu from '../src/Component/Data/Menu/Menu.json';
import menu2 from '../src/Component/Data/Menu/Menu2.json';
import { checkAuth } from './Redux/Actions/authActions';
import { getBaseUrl } from './utils/urlHelper';

function App(props) {
  const { checkAuth, isAuthenticated, loading } = props;
  const [menuData, setMenuData] = useState([...menu.menu]);
  const navigate = useNavigate();
  const baseUrl = getBaseUrl();

  useEffect(() => {
    // Check authentication on mount
    checkAuth();
  }, [checkAuth]);

  const activekey = () => {
    var res = window.location.pathname
    // Normalize PUBLIC_URL - remove /template/cryptoon/react if present
    var normalizedBaseUrl = getBaseUrl() || '/'
    // Remove trailing slash and split
    normalizedBaseUrl = normalizedBaseUrl.replace(/\/$/, '');
    normalizedBaseUrl = normalizedBaseUrl.split("/").filter(Boolean); // Filter out empty strings
    res = res.split("/").filter(Boolean); // Filter out empty strings
    res = res.length > normalizedBaseUrl.length ? "/" + res[normalizedBaseUrl.length] : "/";
    const activeKey1 = res;
    return activeKey1
  }
  
  // Show loading while checking auth
  if (loading && !isAuthenticated) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (activekey() === '/sign-in' || activekey() === '/sign-up' || activekey() === '/forgot-password' || activekey() === '/verification' || activekey() === '/404page') {
    return (
      <div id="cryptoon-layout" className='theme-orange'>
        <AuthIndex />
        <style>{`
          /* Auth pages - black background */
          #cryptoon-layout .main {
            background-color: #000000 !important;
            background: #000000 !important;
            color: #ffffff !important;
          }
          
          #cryptoon-layout .body {
            background-color: #000000 !important;
            background: #000000 !important;
            color: #ffffff !important;
          }
          
          /* Auth page text colors */
          #cryptoon-layout h1,
          #cryptoon-layout h2,
          #cryptoon-layout h3,
          #cryptoon-layout h4,
          #cryptoon-layout h5,
          #cryptoon-layout h6 {
            color: #ffffff !important;
          }
          
          #cryptoon-layout .text-muted {
            color: #cccccc !important;
          }
          
          /* Auth cards */
          #cryptoon-layout .card {
            background-color: #1a1a1a !important;
            border-color: #333333 !important;
            color: #ffffff !important;
          }
          
          #cryptoon-layout .card-body {
            background-color: #1a1a1a !important;
            color: #ffffff !important;
          }
          
          /* Auth forms */
          #cryptoon-layout .form-label {
            color: #ffffff !important;
          }
          
          #cryptoon-layout .form-control,
          #cryptoon-layout .form-select {
            background-color: #2a2a2a !important;
            border-color: #444444 !important;
            color: #ffffff !important;
          }
          
          #cryptoon-layout .form-control:focus,
          #cryptoon-layout .form-select:focus {
            background-color: #2a2a2a !important;
            border-color: #e60205 !important;
            color: #ffffff !important;
          }
          
          #cryptoon-layout .form-control::placeholder {
            color: #888888 !important;
          }
          
          /* Auth nav tabs */
          #cryptoon-layout .nav-link {
            color: #ffffff !important;
          }
          
          #cryptoon-layout .nav-link.active {
            background-color: #e60205 !important;
            color: #ffffff !important;
          }
          
          #cryptoon-layout .nav-link:hover {
            color: #ffffff !important;
          }
          
          /* Auth buttons */
          #cryptoon-layout .btn-primary {
            background-color: #e60205 !important;
            border-color: #e60205 !important;
            color: #ffffff !important;
          }
          
          #cryptoon-layout .btn-primary:hover {
            background-color: #c50204 !important;
            border-color: #c50204 !important;
          }
          
          /* Auth alerts */
          #cryptoon-layout .alert {
            background-color: #2a2a2a !important;
            border-color: #444444 !important;
            color: #ffffff !important;
          }
          
          #cryptoon-layout .alert-danger {
            background-color: #3a1a1a !important;
            border-color: #dc3545 !important;
            color: #ff6b6b !important;
          }
          
          /* Auth links */
          #cryptoon-layout a {
            color: #e60205 !important;
          }
          
          #cryptoon-layout a:hover {
            color: #ff1a1d !important;
          }
          
          /* Container backgrounds */
          #cryptoon-layout .container {
            background-color: transparent !important;
          }
        `}</style>
      </div>
    );
  }
  const GotoChangeMenu = (val) => {
    // Navigate to dashboard and reset menu
      navigate(baseUrl ? baseUrl + '/' : '/')
      setMenuData([...menu.menu]);
  }

  // console.log(activekey())
  return (
    <ProtectedRoute>
      <div id='cryptoon-layout' className='theme-orange'>
        <Sidebar
          activekey={activekey()}
          menuData={menuData}
          GotoChangeMenu={(val) => { GotoChangeMenu(val) }}
        />
        <MainIndex activekey={activekey()}
          GotoChangeMenu={(val) => { GotoChangeMenu(val) }}
        />
        <style>{`
          /* ===== SIDEBAR (RED BACKGROUND) ===== */
          #mainsidemenu.sidebar,
          .sidebar {
            background-color: #e60205 !important;
            background: #e60205 !important;
          }
          
          /* Sidebar text colors - white for visibility on red */
          .sidebar .logo-text,
          .sidebar .brand-icon .logo-text,
          .sidebar .menu-list .m-link,
          .sidebar .menu-list .ms-link,
          .sidebar .menu-list .m-link h6,
          .sidebar .menu-list .m-link small,
          .sidebar .menu-list .ms-link span,
          .sidebar .sidebar-title,
          .sidebar .arrow,
          .sidebar .sidebar-mini-btn {
            color: #ffffff !important;
          }
          
          /* Sidebar active/hover states */
          .sidebar .menu-list .m-link.active,
          .sidebar .menu-list .m-link:hover,
          .sidebar .menu-list .ms-link.active,
          .sidebar .menu-list .ms-link:hover {
            color: #ffffff !important;
            background-color: rgba(255, 255, 255, 0.1) !important;
          }
          
          /* Sidebar icons */
          .sidebar svg path,
          .sidebar .logo-icon i {
            fill: #ffffff !important;
            color: #ffffff !important;
          }
          
          /* Center align logo */
          .sidebar .brand-icon {
            justify-content: center !important;
            text-align: center !important;
          }
          
          .sidebar .logo-icon {
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
            width: 100% !important;
          }
          
          /* ===== MAIN CONTENT AREA (BLACK BACKGROUND) ===== */
          .main {
            background-color: #000000 !important;
            background: #000000 !important;
            color: #ffffff !important;
          }
          
          /* Body area inside main */
          .main .body {
            background-color: #000000 !important;
            background: #000000 !important;
            color: #ffffff !important;
          }
          
          /* Headers and titles */
          .main .body-header,
          .main h1, .main h2, .main h3, .main h4, .main h5, .main h6,
          .main .page-title,
          .main .body-header .pagetitle {
            color: #ffffff !important;
          }
          
          /* Text colors in main area */
          .main p,
          .main span:not(.badge):not(.text-success):not(.text-danger):not(.text-warning):not(.text-info):not(.text-primary),
          .main label,
          .main .text-muted {
            color: #cccccc !important;
          }
          
          /* Cards - dark gray/black with white text */
          .main .card {
            background-color: #1a1a1a !important;
            border-color: #333333 !important;
            color: #ffffff !important;
          }
          
          .main .card-header {
            background-color: #1a1a1a !important;
            border-color: #333333 !important;
            color: #ffffff !important;
          }
          
          .main .card-body {
            background-color: #1a1a1a !important;
            color: #ffffff !important;
          }
          
          .main .card-footer {
            background-color: #1a1a1a !important;
            border-color: #333333 !important;
            color: #ffffff !important;
          }
          
          /* Card titles and headings */
          .main .card-title,
          .main .card h1, .main .card h2, .main .card h3,
          .main .card h4, .main .card h5, .main .card h6 {
            color: #ffffff !important;
          }
          
          /* Tables - ensure proper contrast */
          .main .table {
            color: #ffffff !important;
            background-color: #1a1a1a !important;
          }
          
          .main .table thead,
          .main .table thead th,
          .main .table thead.table-light,
          .main .table thead.table-light th {
            background-color: #2a2a2a !important;
            color: #ffffff !important;
            border-color: #444444 !important;
          }
          
          .main .table tbody {
            background-color: #1a1a1a !important;
          }
          
          .main .table tbody td {
            background-color: #1a1a1a !important;
            color: #ffffff !important;
            border-color: #333333 !important;
          }
          
          .main .table tbody tr {
            background-color: #1a1a1a !important;
            color: #ffffff !important;
          }
          
          .main .table tbody tr:hover,
          .main .table.table-hover tbody tr:hover {
            background-color: #2a2a2a !important;
          }
          
          .main .table tbody tr:hover td {
            background-color: #2a2a2a !important;
            color: #ffffff !important;
          }
          
          /* Table badges and spans inside cells */
          .main .table td .badge,
          .main .table td span:not(.badge) {
            color: inherit !important;
          }
          
          .main .table td .text-success {
            color: #28a745 !important;
          }
          
          .main .table td .text-danger {
            color: #dc3545 !important;
          }
          
          .main .table td .text-warning {
            color: #ffc107 !important;
          }
          
          .main .table td .text-info {
            color: #17a2b8 !important;
          }
          
          .main .table td .text-muted {
            color: #cccccc !important;
          }
          
          /* Table card specific styling */
          .main .table-card .table {
            background-color: #1a1a1a !important;
          }
          
          .main .table-card .table thead th {
            background-color: #2a2a2a !important;
            color: #ffffff !important;
          }
          
          .main .table-card .table tbody td {
            background-color: #1a1a1a !important;
            color: #ffffff !important;
          }
          
          .main .table-card .table tbody tr.trade-row {
            background-color: #1a1a1a !important;
          }
          
          .main .table-card .table tbody tr.trade-row:hover {
            background-color: #2a2a2a !important;
          }
          
          .main .table-card .table tbody tr.trade-row:hover td {
            background-color: #2a2a2a !important;
            color: #ffffff !important;
          }
          
          /* Forms */
          .main .form-label,
          .main .form-control,
          .main .form-select {
            color: #ffffff !important;
          }
          
          .main .form-control,
          .main .form-select {
            background-color: #2a2a2a !important;
            border-color: #444444 !important;
          }
          
          .main .form-control:focus,
          .main .form-select:focus {
            background-color: #2a2a2a !important;
            border-color: #dc3545 !important;
            color: #ffffff !important;
          }
          
          /* Badges - keep their colors but ensure text is readable */
          .main .badge {
            color: #ffffff !important;
          }
          
          /* Pagination */
          .main .pagination .page-link {
            background-color: #2a2a2a !important;
            border-color: #444444 !important;
            color: #ffffff !important;
          }
          
          .main .pagination .page-link:hover {
            background-color: #dc3545 !important;
            border-color: #dc3545 !important;
            color: #ffffff !important;
          }
          
          .main .pagination .page-item.active .page-link {
            background-color: #dc3545 !important;
            border-color: #dc3545 !important;
          }
          
          /* Containers */
          .main .container-xxl,
          .main .container-fluid {
            background-color: transparent !important;
          }
          
          /* TradingView ticker strips - make them black */
          .main .card.rounded-0,
          .main .container-fluid .card.rounded-0,
          .main .container-fluid .row .card.rounded-0,
          .main .container-fluid .row .col-12 .card.rounded-0 {
            background-color: #000000 !important;
            border-color: #000000 !important;
            border: none !important;
          }
          
          .main .card.rounded-0 .card-body,
          .main .container-fluid .card.rounded-0 .card-body {
            background-color: #000000 !important;
            padding: 0 !important;
            border: none !important;
          }
          
          .main .card.rounded-0 iframe,
          .main .container-fluid .card.rounded-0 iframe {
            background-color: #000000 !important;
            border: none !important;
          }
          
          /* Ensure row and container backgrounds are also black */
          .main .container-fluid.px-0 {
            background-color: #000000 !important;
          }
          
          .main .container-fluid .row.gx-0 {
            background-color: #000000 !important;
          }
          
          .main .container-fluid .row .col-12 {
            background-color: #000000 !important;
          }
          
          /* Statistics cards - adjust for black background */
          .main .stats-card {
            background-color: #1a1a1a !important;
          }
          
          /* Empty states */
          .main .empty-state h5,
          .main .empty-state p {
            color: #cccccc !important;
          }
        `}</style>
      </div>
    </ProtectedRoute>
  );
}
const mapStateToProps = (state) => ({
  Mainreducer: state.Mainreducer,
  isAuthenticated: state.auth?.isAuthenticated || false,
  loading: state.auth?.loading || false,
})

export default connect(mapStateToProps, {
  checkAuth
})(App);
